<template>
  <div style="display: flex; flex-wrap: wrap">
    <draggable
      :list="groups"
      @update="dragUpdateHandler"
      :disabled="
        type == 1
          ? !hasAuth('productTemplateEdit')
          : !hasAuth('instrumentTemplateEdit')
      "
      style="display: flex; flex-wrap: wrap; gap: 10px"
      filter=".draggable"
    >
      <div :key="item.id" v-for="(item, index) in groups">
        <div v-if="index == editIndex">
          <el-input
            class="input-new-tag"
            v-model="inputValue"
            ref="editInput"
            size="small"
            @keyup.enter.native="handleUpdate(item.id, index)"
            @blur="handleUpdate(item.id, index)"
          >
          </el-input>
        </div>
        <el-tag
          v-else
          class="pointer"
          :effect="item.id == selectedid ? 'light' : 'plain'"
          :type="item.id == selectedid ? 'primary' : 'info'"
          @click="handleSelect(item)"
          >{{ item.name }}
          <span
            v-permission="
              type == 1 ? Auth.productTemplateEdit : Auth.instrumentTemplateEdit
            "
          >
            <i
              class="ml-10 el-icon-edit"
              @click.stop="handleEdit(item, index)"
              v-if="item.id == selectedid"
            ></i>
            <i
              @click.stop="handleDelete(item, index)"
              class="ml-10 el-icon-delete"
              v-if="item.id == selectedid && canDelete"
            ></i>
          </span>
        </el-tag>
      </div>
      <div class="draggable">
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button
          v-else
          class="button-new-tag"
          size="small"
          @click="showInput"
          v-permission="
            type == 1 ? Auth.productTemplateEdit : Auth.instrumentTemplateEdit
          "
          >+ 新分组</el-button
        >
      </div>
    </draggable>
  </div>
</template>

<script>
import { templateGroupList, templateGroupSort } from '@/service/getData'
import draggable from 'vuedraggable'
import {
  templateGroupDelete,
  templateGroupNew,
  templateGroupUpdate,
} from '../../service/getData'
export default {
  components: {
    draggable,
  },
  props: {
    value: '',
    selected: Number,
    type: Number,
    codeType: {
      type: Number,
      default: 1,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    codeType: 'getGroups',
  },
  data() {
    return {
      groups: [],
      inputVisible: false,
      inputValue: '',
      selectedid: 0,
      editIndex: -1,
    }
  },
  created() {
    this.getGroups()
    // this.selectedid = this.value
  },
  methods: {
    async getGroups() {
      let res = await templateGroupList({
        type: this.type,
        code_type: this.codeType,
      })
      if (res.code != 0) return
      this.groups = res.data
      if (this.groups.length > 0) {
        this.selectedid = this.groups[0].id
        this.$emit('input', this.selectedid)
      } else {
        this.$emit('input', '')
      }
    },
    handleSelect(item) {
      this.selectedid = item.id
      this.$emit('input', this.selectedid)
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleEdit(item, index) {
      this.editIndex = index
      this.inputValue = item.name
      this.$nextTick((_) => {
        this.$refs['editInput'][0].$refs.input.focus()
      })
    },
    async handleUpdate(id, index) {
      if (!this.inputValue) {
        this.inputVisible = false
        return
      }
      let res = await templateGroupUpdate({
        name: this.inputValue,
        id: id,
      })
      if (res.code == 0) {
        this.groups[index].name = res.data.name
        this.inputValue = ''
        this.editIndex = -1
      }
    },
    handleDelete(item, index) {
      this.$confirm('确认删除该分组吗？').then(async (_) => {
        let res = await templateGroupDelete(item.id)
        if (res.code == 0) {
          this.groups.splice(index, 1)
          this.selectedid = this.groups[0].id
          this.$emit('input', this.selectedid)
        }
      })
    },
    async handleInputConfirm() {
      if (!this.inputValue) {
        this.inputVisible = false
        return
      }
      let res = await templateGroupNew({
        name: this.inputValue,
        type: this.type,
        code_type: this.codeType,
      })
      if (res.code == 0) {
        this.groups.push(res.data)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    dragUpdateHandler() {
      var ids = this.groups.map((item) => {
        return item.id
      })
      templateGroupSort({
        ids: ids,
      })
    },
  },
}
</script>

<style scoped>
.button-new-tag {
  /* margin-left: 10px; */
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  /* margin-left: 10px; */
  vertical-align: bottom;
}
</style>